import { StyledTable } from './AntdTable.styled'
import { Arrow } from '@app/icons'
import cl from 'classnames'
import styles from './AntdTable.module.scss'
import { forwardRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TableProps } from 'antd'

export const AntdTable = forwardRef((props: TableProps, ref) => {
	const { t } = useTranslation()

	return (
		<StyledTable
			{...props}
			ref={ref}
			expandIcon={({ expandable, expanded, onExpand, record }) => {
				return expandable && (
					<Arrow className={cl(styles.icon, { [styles.icon__expanded]: expanded })}
								 onClick={e => onExpand(record, e)} />
				)
			}}
			locale={{
				emptyText: t('table_empty_data'),
			}}
		/>
	)
})